import { useState } from 'react';

export function useCollapsibleItemForm() {
  const [formExpanded, setFormExpanded] = useState(false);

  function expandForm(): void {
    setFormExpanded(true);
  }

  /** Limpa os campos e colapsa o formulário (Cancelar / sucesso de criação). */
  function collapseForm(reset: () => void): void {
    setFormExpanded(false);
    reset();
  }

  function handleCreateSuccess(reset: () => void): void {
    collapseForm(reset);
  }

  function toggleForm(): void {
    setFormExpanded((current) => !current);
  }

  /** Expande; se já estiver aberto, limpa campos e colapsa. */
  function toggleOrCancel(reset: () => void): void {
    if (formExpanded) {
      collapseForm(reset);
    } else {
      expandForm();
    }
  }

  return {
    formExpanded,
    expandForm,
    collapseForm,
    handleCreateSuccess,
    toggleForm,
    toggleOrCancel,
  };
}
